import { render, staticRenderFns } from "./cquery.vue?vue&type=template&id=a90b1340&scoped=true"
import script from "./cquery.vue?vue&type=script&lang=js"
export * from "./cquery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90b1340",
  null
  
)

export default component.exports